import React from "react";
import Main from "./pages/main";
import {Routes} from "react-router";
import NavBar from "./pages/components/NavBar";
import {Route}
  from 'react-router-dom';
import Request from "./pages/request";
import About from "./pages/about";

function App() {
  return (
    <>
      <NavBar/>
      <Routes>
        <Route exact path='/' element={<Main/>}/>
        <Route exact path='/home' element={<Main/>}/>
        <Route path='/request' element={<Request />}/>
        <Route path='/about' element={<About/>}/>
      </Routes>
    </>
  );
}

export default App;
